// extracted by css-extract-rspack-plugin
export default {"card":"hjZ93gemxUZyjnk_"};